import { render, staticRenderFns } from "./SalesOrderPayment.vue?vue&type=template&id=04ab0408&scoped=true"
import script from "./SalesOrderPayment.vue?vue&type=script&lang=js"
export * from "./SalesOrderPayment.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderPayment.vue?vue&type=style&index=0&id=04ab0408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab0408",
  null
  
)

export default component.exports